<style scoped>

.about-text {
    font-size: 16px;
    color: #212322;
    text-align: justify;
    padding-top: 100px;
    padding-bottom: 100px;
    padding-left: 20px;
    padding-right: 280px;
}

.larger_text {
    font-size: 20px;
    color: #696969;
  
}

.larger_text_2 {
      font-size: 20px;

}

h3 {
    font-family: "Open Sans", sans-serif;
    font-size: 30px;
    font-weight: bold;
}

p {
    font-family: "Inconsolata", monospace;
}



a:hover {
  color: hotpink;
  text-decoration: none;

}

a {
  color: #800080;
}


@media (max-width: 575px) {
  p {
    text-align: left;
    line-height: 1.6;
    
  }

  .about-text {
    padding-right: 10px;
  }

  br {
   display: block;
   margin: 10px 0;
}

.larger_text {
    font-size: 20px;
    font-weight: bold;
    color: #696969;
  
}


}
</style>

<template>

  <b-container fluid>
    <MenuBar/>

<b-row class="about-text">
  <p>A space to collect my writing and experiments. </p>
</b-row>

<b-row>
  <b-col md='12'>
  <b-list-group horizontal>
  <b-list-group-item href="#kefir">Fermenting water kefir</b-list-group-item>
  <b-list-group-item href="#">Magnolia syrup</b-list-group-item>
  
</b-list-group>
</b-col>
</b-row>
<b-row>
<b-col md='7'>
  <br>
  <h3 id="kefir">Fermenting water kefir</h3>

  <br>

  <p>I love fizzy drinks, and I'd rather not have to buy them. While this is not the sole reason why I started (but really, store-bought kombucha is not nice at all), over the past few years, I've experimented with fermenting my own drinks. I've tried many different flavors, and a couple of different methods. My current method of choice, since January 2026: water kefir.
  </p>
  <p>Water kefir is a fermented drink produced with the use of water kefir grains. This is one of many names to describe a symbiotic culture of bacteria and yeasts (SCOBY) - tibicos, Tibetan crystals, Japanese water crystals, etc. The grains I have are less than 1cm in size, transparent and colourless, slightly firm but also jelly-like. They self-propagate when taken care of properly. I've purchased them online from <a href="https://www.kefirshop.nl/">Kefirshop</a>, but it's nicer if you can get them from someone you know, who most likely will have more than they can make use of. The resources I've used so far have been Sandor Katz's book 'The Art of Fermentation' and Dom Anfiteatro's extensive research from <a href="https://myfermentedlife.com/kefir-grains/"> 'My Fermented Life'</a>. </p>
  <p>
  The first starter culture I've ever received were a couple of milk kefir grains. It was 2018, and I had just taken part in a workshop on milk kefir at the Chaos Communication Congress <a href="https://events.ccc.de/congress/2018/wiki/index.php/Main_Page">(35C3)</a> given by Algoldor from <a href="https://foodhackingbase.org/wiki/Food_Hacking_Base"> Food Hacking Base </a>. I transported them home, back from Germany, in a small jar with some milk just enough to cover them. I still have these grains, or better said their descendants, but they have not been cared for properly in years. I then got some kombucha SCOBY and started a couple of sourdoughs. In the winter, I fill up a 30l container with cauliflower, beets, horseradish and other veggies, herbs and condiments, and start my lactofermented batch of pickles that keeps for months and months on the balcony. Caring for these ferments is a ritual that I enjoy preserving, as it reminds me of my family's yearly cycles of harvesting and preserving, a natural part of their lives for generations.
  </p>

  <p>Sometime in 2024 I was given a small package of powdered water kefir grains, which I forgot about for about a year. When I finally decided to give it a try by adding it to a jar with sugar and water, I was disappointed. After a couple of days, not much had happened. I tossed it all out and decided to try again with some 'wet' grains. The tiny plastic pouch I received from the kefir website contained 20g of small grains in a little liquid, and some instructions on how to get started. Their recipe is as follows:</p>
<p>
  <pre>
    * 1 part kefir grains
    * 1/2 part sugar
    * 10 parts water
    * 1 date or other dried fruit
</pre>
    Add to a jar, close and wait for a 2 days to ferment. Afterwards, strain the grains and add the liquid to a bottle, place in fridge and you can start drinking.
 
 </p> 
<p>
  I've been following this recipe, more or less, ever since. The processes they describe include a first and a second fermentation. During the first fermentation, you can already start seeing some bubbling, but your liquid will not be carbonated yet. It will start smelling slightly sour. If you've added dried fruit, a layer of foamy bubbles may have also formed on top of the liquid. That's when you know it's time to bottle. Strain out the grains, and put them back in the jar, reserve the liquid water kefir. I use 750ml swing-top bottles, which I fill with water kefir up to about 3 fingers from the bottom. I fill up the rest with water, up to just below the shoulder of the bottle (look up the anatomy of a bottle, I just did also!) to leave some space for flavors and air. Now add whatever flavors you'd like, and a couple of spoonfuls of sugar. I never measure from now onwards, so just test what you find tasty. My favorite flavor and color combination is adding a yellow kiwi, cut into strips (so it can fit through the neck, both in and out), as well as a few butterfly pea flowers, which turn the drink gradually, from top to bottom, into a pastel purple.
</p>
<p>
  Some other flavor combinations that I've tried:

  <pre>

    * ginger, turmeric root, lemon
    * molasses, lemon and vanilla extract
    * blueberry juice
    * raspberry, turmeric root
    * kiwi, mint
  </pre>
</p>
<p>My ambition is to one day replicate the flavor of Dr. Pepper (or even better, <a href="https://thefizzreview.wordpress.com/2012/06/27/dr-foots/">Dr. Foots</a>). Until then, I'm experimenting in slow batches with different fruit combinations. In between making new batches, I keep the grains in a sugary water solution, and feed them extra sugar every couple of days. If the fermented liquid becomes too sour, and I'm not ready yet to use it, I strain the grains and start again with water and sugar.
</p>
<p>
  I'm sharing my drinks and part of the kefir grain culture with those who are interested to try it out themselves. Together with my friend Bauwien, we're doing some fermented drinks workshops around Rotterdam, for now in <a href="https://radar.squat.net/en/rotterdam/snackbar-frieda">Snackbar Frieda</a>. This is also a continuation of the fermentation work that I've been doing within <a href="https://portfolio.alicestrete.me/fizz">Fizz Club</a>, a slightly dormant but ever living little project.

</p>
</b-col>
<b-col md='3' offset-md='1'>
  <br>

  <b-img class="img-fluid" src="media/writing/kefir2.gif"></b-img>
  <br>

  <b-img class="img-fluid" src="media/writing/kefir3.gif"></b-img>
  <br>

  <b-img class="img-fluid" src="media/writing/kefir5.jpg"></b-img>

</b-col>
</b-row>

</b-container>

</template>

<script>

import MenuBar from './MenuBar'
export default {
    name: 'AboutPage',
    components: {
        MenuBar
    }
}

</script>
